import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AoFeatureShellModule } from '@ao/feature-shell';
import { environment } from '@ao/util-environment';
import { RUNTIME_CONFIG } from '@common/util-foundation';
import { RuntimeConfig } from '@common/util-models';
import { ScullyLibModule } from '@scullyio/ng-lib';
import { POSTHOG_CONFIG } from '../../../../libs/tracking/posthog/posthog-config.token';
import { PostHogService } from '../../../../libs/tracking/posthog/posthog.service';
import { AppComponent } from './app.component';
import { COMPONENT_MAPPING } from './cms-config/cms-component-mapping.config';
import { cmsDataUrl } from './cms-config/cms-data-url';
import {
  gaTagsConfig,
  googleTagGlobalProps,
} from './ga-tags-config/ga-tags-config';

export function initPostHog(postHogService: PostHogService) {
  return () => postHogService.init();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AoFeatureShellModule.forRoot({
      componentMapping: COMPONENT_MAPPING,
      gaTagsConfig,
      cmsDataUrl,
      googleTagGlobalProps,
    }),
    ScullyLibModule,
  ],
  providers: [
    { provide: 'isDevelopmentEnvironment', useValue: !environment.production }, // to enable debug logger
    {
      provide: POSTHOG_CONFIG,
      useFactory: (runtimeConfig: RuntimeConfig) => {
        const posthogConfig = (runtimeConfig as any)?.posthog || {
          key: '',
          host: '',
        };
        return {
          apiKey: posthogConfig.key,
          apiHost: posthogConfig.host,
          personProfiles: true,
          debug: !environment.production,
        };
      },
      deps: [RUNTIME_CONFIG],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initPostHog,
      deps: [PostHogService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
